import { render, staticRenderFns } from "./MessageMobile.vue?vue&type=template&id=107b91ea&scoped=true&"
import script from "./MessageMobile.vue?vue&type=script&lang=ts&"
export * from "./MessageMobile.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMobile.vue?vue&type=style&index=0&id=107b91ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b91ea",
  null
  
)

export default component.exports